<template>
  <div class="main">
    <el-container>
      <el-header>健康水平实验评估系统</el-header>
      <el-main>
        <el-row>
          <el-col
            :xs="{ span: 24, offset: 0 }"
            :sm="{ span: 24, offset: 0 }"
            :md="{ span: 16, offset: 4 }"
            :lg="{ span: 12, offset: 6 }"
            :xl="{ span: 12, offset: 6 }"
            class="description-box"
          >
            <ol>
              <li>
                本评估系统基本原理是以常规实验指标建立的数学模型为基础，对一般健康状态进行量化评估。
              </li>
              <li>
                健康到疾病是一个连续的过程，本系统以综合评分50分为界区分健康状态良好和疾病前驱状态（分数越高，疾病风险越高），年龄超过50岁判断界值需要校正为：（年龄+5）
              </li>
              <li>
                如同衰老不一定患病，患病不一定衰老一样，一般健康状态良好并不意味着没有躯体疾病，有躯体疾病也不一定是健康状态不好。所以健康状态与疾病既互相独立，又互相联系。本评估系统对结果解释的理论基础是慢性疾病前驱状态理论【见结果页面和参考文献：Guang
                Y, Yuzhong L, Hui L. A grading system from health to death using
                routine experimental indicators based on the pre-chronic disease
                status theory. BMC Geriatr.
                2020;20(1):250.】。疾病前驱状态理论试图在分子水平探讨疾病的发生、发展和结局。本系统综合评分>50可以认为是疾病前驱状态。
              </li>
              <li>
                本系统对构成综合评分的基础指标也进行了呈现，一般认为各分项指标 <
                50分为健康。其中，运动缺乏和肥胖与现代慢性病关系密切，疾病前驱状态理论认为疾病前驱状态可以通过非医疗干预（饮食、运动或休息）而逆转，因此，本系统还可用于健康管理。本项目曾获辽宁省科技进步二等奖（2017-J-2-47-R01）
              </li>
            </ol>
            <el-button @click="$router.back(-1)" type="primary" style="margin-top:20px">
              返回
            </el-button>
          </el-col>
        </el-row>
      </el-main>
      <!-- <el-footer>版本 V3.0</el-footer> -->
    </el-container>
  </div>
</template>

<script>
export default {
  name: "Description",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>

<style scoped lang='scss'>
ol {
  margin: 0px;
  padding: 0 0 0 15px;
  text-align: justify;
  li {
    line-height: 40px;
  }
}
.description-box {
  padding: 20px ;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
}
</style>
